import * as t from 'io-ts';

export const ssoRedirect = t.type({
  url: t.string,
});

export type SsoRedirectData = t.TypeOf<typeof ssoRedirect>;
